module.exports = __webpack_public_path__ + "img/transparent-nav-right-ford.e6d78789.png";